import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconFoundations({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M7.27 6a3.5 3.5 0 1 1 2.37 3.314l-.913.697a4.5 4.5 0 1 0-2.334-5.062c.19.045.36.18.43.406l.595 1.924a.6.6 0 0 0 .237.32A3.485 3.485 0 0 1 7.27 6z"/>
            <path stroke={fill} d="m4.605 7.131.477.148-.477-.148a.1.1 0 0 1-.096.07H2.524c-1.052 0-1.504 1.336-.668 1.975l1.657 1.266a.1.1 0 0 1 .035.109l-.62 2.008c-.317 1.023.867 1.849 1.718 1.199l1.543-1.18a.1.1 0 0 1 .122 0l1.543 1.18c.851.65 2.035-.176 1.719-1.2l-.62-2.007a.1.1 0 0 1 .034-.11l1.657-1.265c.836-.639.384-1.974-.668-1.974H7.991a.1.1 0 0 1-.096-.07l-.594-1.925c-.32-1.033-1.783-1.033-2.102 0l-.594 1.924z"/>
        </svg>
    );
}

export default IconFoundations;
